import React, { useState } from 'react';

import { AppBar, Drawer, IconButton, Toolbar } from '@mui/material';

import MenuIcon from '@mui/icons-material/Menu';

import Logo from '../../../Assets/Logo/white.png';

import { useIsMobile } from '../../../Hooks/useIsMobile';

const MobileNavWrapper = ({ children }) => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const isMobile = useIsMobile();

  if (!isMobile) return <>{children}</>;

  return (
    <AppBar
      component='nav'
      sx={{ height: 'fit-content' }}
      color='blue'
      position='relative'
      elevation={0}>
      <Toolbar sx={{ display: { md: 'none' } }}>
        <IconButton
          aria-label='open drawer'
          edge='start'
          sx={{ color: 'white' }}
          onClick={() => setIsNavOpen(true)}>
          <MenuIcon />
        </IconButton>
        <img
          src={Logo}
          alt='Logo'
          style={{
            width: '50%',
            marginInline: 'auto',
            maxWidth: '200px',
            paddingBlock: '20px',
          }}
        />
      </Toolbar>
      <Drawer open={isNavOpen} anchor='left' onClose={() => setIsNavOpen(false)} keepMounted>
        {children}
      </Drawer>
    </AppBar>
  );
};

export default MobileNavWrapper;
